import { Link } from "@mui/material";
import IntlMessages from "../../../util/IntlMessages";

const LinkButton = ({ label, click, disabled, ...props }) => {
  return (
    <Link
      href="#"
      onClick={disabled ? undefined : click}
      sx={
        disabled
          ? { pointerEvents: "none", opacity: 0.38, cursor: "default" }
          : undefined
      }
      {...props}
    >
      <IntlMessages id={label} />
    </Link>
  );
};

export { LinkButton };
